import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ColDef } from 'ag-grid-community';
import { BehaviorSubject, combineLatest, merge, of } from 'rxjs';
import { filter, map, switchMap, debounceTime } from 'rxjs/operators';
import { FilterDateRangeValue, FilterFieldType, FilterFieldValue } from '../../../covance-filter';
import { CovanceFilterDateRangeType } from '../../../covance-filter/filter-type/covance-filter-date-range-type';
import { zcProjectNumberColumn } from '../../../documents';
import {emailColumn, protocolNameColumn, sponsorNameColumn, userNameColumn, buildDateTimeColumn, getSiteNameColumn, getCompositeSiteColumn} from '../../../shared';
import { AdminAccessInvestigationsStorage } from './admin-access-investigations-storage';
import { UserSearch } from '../../users/user-search';
import { AdminAccessinvestigationReport } from '../report-types/admin-access-investigation-report';

@Component({
    selector: 'app-admin-access-investigation-reports',
    template: require('./admin-access-investigation-reports.component.html'),
    styles: [require('./admin-access-investigation-reports.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminAccessInvestigationReportsComponent {
    public filterFieldVal: FilterFieldValue = {
        def: {
            title: 'Posted',
            queryParam: 'postedDateTime',
            type: FilterFieldType.DateRange
        },
        value: {}
    };
    public usersControl = new FormControl(null, Validators.required);
    public selectedDateRange$ = new BehaviorSubject<FilterDateRangeValue>(null);
    public isEmptyDateRange$ = this.selectedDateRange$.pipe(map(x => x == null));

    public readonly columnDefs: ColDef[] = [
        userNameColumn,
        emailColumn,
        sponsorNameColumn,
        protocolNameColumn,
        zcProjectNumberColumn,
        getCompositeSiteColumn(),
        buildDateTimeColumn<AdminAccessinvestigationReport, 'startDateTime'>('startDateTime', 'Access Start'),
        buildDateTimeColumn<AdminAccessinvestigationReport, 'endDateTime'>('endDateTime', 'Access End'),
        buildDateTimeColumn<AdminAccessinvestigationReport, 'actionDateTime'>('actionDateTime', 'Action Time'),
        {
            headerName: 'Module',
            field: 'module',
        },
        {
            headerName: 'Content',
            field: 'action',
        }
    ];

    public readonly reports$ = merge(
        of([]),
        combineLatest(
            this.usersControl.valueChanges.pipe(
                filter(u => !!u),
                map((users: UserSearch[]) => users[0].userPk)
            ),
            this.selectedDateRange$.pipe(
                filter(d => !!d)
            )
        ).pipe(
            debounceTime(300),
            switchMap(([userPk, dateRange]) =>
                merge(
                    of(null),
                    this.accessInvestigationsStorage.getReports(userPk, dateRange.dateBegin, dateRange.dateEnd)
                )
            )
        ));

    constructor(
        private accessInvestigationsStorage: AdminAccessInvestigationsStorage,
        private dateRangeType: CovanceFilterDateRangeType,
    ) { }

    public onDateChange(filterFieldValue: FilterFieldValue) {
        this.dateRangeType.setValue(filterFieldValue);
        this.selectedDateRange$.next(filterFieldValue.value);
    }
}
